<template>
  <div class="share-store" :style="mainStyle">
    <LoadingComponents />
    <wownow-image
      :src="bgImg"
      class="mask-group-background"
      :style="backgroundImageStyle"
    />
    <!-- 头部 -->
    <div class="header-box">
      <div class="wownow-logo">
        <img src="./images/wownow_logo@2x.png" alt="wownow" />
      </div>
    </div>
    <div class="cnt">
      <!-- 不存在门店 -->
      <template v-if="!isLoading && isStoreError">
        <div class="no-store position-absolute">
          <img src="./images/error_img@2x.png" alt="wownow" />
          <p class="no-tip">{{ $t("home.noStore") }}</p>
          <div class="btn" @click="buttonClick">{{ $t("home.openapp") }}</div>
        </div>
      </template>
      <template v-if="!isLoading && detail">
        <div class="content-box position-absolute">
          <div class="logo-box">
            <div class="logo">
              <img :src="detail.logo" />
            </div>
            <p class="name">{{ storeName }}</p>
            <div class="desc-box">
              <!-- 评分 -->
              <div class="score item">
                <img src="./images/star.png" alt="" />
                <span v-if="detail.reviewScore - 0 <= 0">{{
                  $t("home.noScore")
                }}</span>
                <span v-else>{{ detail.reviewScore }}</span>
                <span class="point">·</span>
              </div>
              <div class="classification item" v-for="(item,index) in businessScopes"  :key="index">
                <span>{{ item }}</span>
                <span class="point">·</span>
              </div>
              <div class="prepareTime item">
                <img src="./images/ding.png" alt="" />
                <span>{{ detail.deliveryTime + "mins" }}</span>
              </div>
            </div>
          </div>
          <!-- 内容 -->
          <div class="info-box">
            <!-- 商品优惠 -->
            <div class="discountItem item" v-if="promotionObj.discountTitle">
              <span class="title">{{ $t("home.discountTitle") }}</span>
              <em>{{ promotionObj.discountTitle }}</em>
            </div>
            <!-- 爆品 -->
            <div class="discountItem item" v-if="promotionObj.bestTitle">
              <span class="title">{{ $t("home.discountTitle") }}</span>
              <em>{{ promotionObj.bestTitle }}</em>
            </div>
            <!-- 配送费 -->
            <div class="deliveryFee item">
              <span class="title">{{ $t("home.DeliveryFee") }}</span>
              <em>{{ deliveryFee }}</em>
            </div>
            <!-- 满减 -->
            <div
              class="FullReduction item"
              v-if="promotionObj.fullReductionActivityNo"
            >
              <span class="title">{{ $t("home.fullReductionTitle") }}</span>
              <em>{{ promotionObj.FullReductionDesc }}</em>
            </div>
            <!-- 首单 -->
            <div
              class="storeFirst item"
              v-if="promotionObj.storeFirstActivityNo"
            >
              <span class="title">{{ $t("home.storeFirstTitle") }}</span>
              <em>{{ promotionObj.storeFirstDesc }}</em>
            </div>
            <!-- 优惠券 -->
            <div class="coupon item" v-if="promotionObj.storeCouponDesc">
              <span class="title">{{ $t("home.couponTitle") }}</span>
              <em>{{ promotionObj.storeCouponDesc }}</em>
            </div>
          </div>
          <div class="btn" @click="buttonClick">{{ $t("home.openapp") }}</div>
        </div>
      </template>
      <!-- openapp -->
      <!-- <OpenAppBtn ref="OpenAppBtn" :pathParam="routePath"></OpenAppBtn> -->
      <transition name="slide-fade">
        <div
          class="masking"
          v-if="isShowMasking"
          @click="isShowMasking = false"
        >
          <div class="masking-content">
            <div class="masking-tips-site">
              <div class="tips-row">
                <div class="round display-middle">1</div>
                <div class="display-middle tips-text">
                  {{ maskingLang.one.one }}
                </div>
                <img
                  class="display-middle blue-menu"
                  :src="logoImgs.blueMenuImageSrc"
                />
                <div class="display-middle tips-text">
                  {{ maskingLang.one.two }}
                </div>
              </div>
              <div class="tips-row">
                <div class="round display-middle">2</div>
                <div class="display-middle tips-text">
                  {{ maskingLang.two.one }}
                </div>
                <div class="display-middle blue-button-site">
                  <img
                    class="display-middle blue-button"
                    :src="logoImgs.blueButtonImageSrc"
                  />
                  <img class="earth" :src="logoImgs.earthImageSrc" />
                  <div class="tips-text earth-text">
                    {{ maskingLang.two.two }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <WxOpenLaunchApp
        :extinfoProps="goAppRouter"
        v-if="!!isWechat && wechatAppid"
        :appid="wechatAppid"
        @click="wxOpenLaunchAppClick"
        :clientWidth="$root.clientWidth"
        :clientHeight="$root.clientHeight"
        @launch-error="launchError"
      />
    </div>
  </div>
</template>

<script>
import languageUtils from "$common/utils/language";
import promotionMixin from "./mixins/promotionMixin";
import storage from "$common/utils/storage";

import LoadingComponents from "$superAppUser/components/loading-components";
import {
  getStoreDetail,
  getImagePath,
  getDiscountFee
} from "$shareStore/apis/gateway-web/store";
import WechatJssdk from "$common/utils/wechat/web-jssdk";
import WxOpenLaunchApp from "$common/components/wechat/wx-open-launch-app";
import DebugLint from "./debug-lint";
// import OpenAppBtn from "$lottery/components/OpenAppBtn/index";
import Score from "./components/score";
import { uploadEventList } from "$common/utils/event-tracking/page";

export default {
  documentTitle: "WOWNOW-Food Delivery",
  components: {
    WxOpenLaunchApp,
    DebugLint,
    // OpenAppBtn,
    LoadingComponents,
    Score
  },
  mixins: [promotionMixin],
  created() {
    WechatJssdk.config()
      ?.then(res => WechatJssdk?.share())
      ?.catch(err => {
        console.log("WechatJssdk err: ", err);
      });
  },
  data() {
    return {
      isShowMasking: false,
      detail: window?.ssrConfig?.routerConfig?.storeDetail ?? undefined,
      btnActive: false,
      wechatAppid: window?.ssrConfig?.routerConfig?.appid ?? "",
      isLoading: !!window?.ssrConfig?.routerConfig?.storeDetail ?? true,
      // wownowTool
      // window.wownowTool.getScheme
      // iosUrl:'',
      iosUrl: window.wownowTool.getScheme(window?.ssrConfig?.routerConfig?.scheme?.ios ?? "superapp://h5.lifekh.com/wakeup?routepath="),
      isStoreError: false,
      userInfo: {},
      bgImg: 'https://img.tinhnow.com/wownow/files/pro/app/datasource/MEF/BF/BD/0099fdaab46e4e1bb69c1053a5a323d7.jpg'
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getOperator(true);
      this.getStoreDetail();
      this.ajaxgetImagePath();
      this.ajaxGetPromotionList();

      // 埋点
      this.commonUploadEvenlist({
        event: "enterH5Page",
        businessName: "进入H5门店承载页",
        type: "enterH5Page"
      });
    });
  },
  computed: {
    lang() {
      const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
      return navigatorLanguage.indexOf("zh") !== -1
        ? "zh"
        : navigatorLanguage.indexOf("en") !== -1
        ? "en"
        : "km";
      // return 'en';
      // return 'km';
    },
    mainStyle() {
      return (
        (this.$root.clientHeight && `height: ${this.$root.clientHeight}px;`) ||
        ""
      );
    },
    backgroundImageStyle() {
      return (
        (this.$root.clientHeight &&
          `min-height: ${this.$root.clientHeight}px;`) ||
        ""
      );
    },
    goAppRouter() {
      return this?.locationQuery?.routePath ?? "";
    },
    isIOS() {
      return navigator.userAgent.toLocaleLowerCase().indexOf("mac os x") !== -1;
    },
    locationQuery() {
      try {
        return this.urlQueries();
      } catch (err) {
        console.log("整理参数失败: ", err);
        return {};
      }
    },
    routePath() {
      // 这里都是解码参数
      let routePath =
        this.locationQuery.routePath || this.locationQuery.routepath || "";
      const preFixRoute =
        (this.isIOS && this.iosUrl) || "superapp://tinhnow/delivery?url=";
      if (this.isWownowApp) {
        return `${routePath}`;
      }
      // 编码
      routePath = encodeURIComponent(routePath);
      return `${preFixRoute}${routePath}`;
    },
    maskingLang() {
      return {
        one: {
          one: (this.lang === "zh" && "点击右上角的") || "点击右上角的",
          two: (this.lang === "zh" && "按钮") || "按钮"
        },
        two: {
          one: (this.lang === "zh" && "选择") || "选择",
          two: (this.lang === "zh" && "在浏览器中打开") || "在浏览器中打开"
        }
      };
    },
    logoImgs() {
      return {
        blueMenuImageSrc: require("./images/blue-menu.png"),
        blueButtonImageSrc: require("./images/blue-button.png"),
        earthImageSrc: require("./images/earth.png"),
        google: {
          src: require("./images/google-logo.png"),
          style: "width: 0.7rem;padding-top: 0.08rem;"
        },
        android: {
          src: require("./images/android-logo.png"),
          style: "width: 0.67rem;"
        },
        apple: {
          src: require("./images/apple-logo.png"),
          style: "width: 0.67rem;padding-top: 0.08rem;"
        }
      };
    },
    isDingTalk() {
      return navigator.userAgent.toLowerCase().indexOf("dingtalk") !== -1;
    },
    isQQ() {
      return navigator.userAgent.toLowerCase().indexOf("qq/") !== -1;
    },
    isWechat() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
      // return true
    },
    isFaceBook() {
      return !!(
        navigator.userAgent.indexOf("fbav") !== -1 ||
        navigator.userAgent.indexOf("fban") !== -1 ||
        navigator.userAgent.indexOf("fbios") !== -1 ||
        navigator.userAgent.indexOf("facebook") !== -1
      );
    },
    // 门店名称
    storeName() {
      if (!this.detail) return null;
      return this.lang === "en"
        ? this.detail.storeName
        : this.lang === "zh"
        ? this.detail.storeNameZh
        : this.detail.storeNameKm;
    },
    // 只取一级分类
    businessScopes() {
      let classificationNameArr = this.detail.businessScopesV2.map(
        i => i.classificationName
      );
      return classificationNameArr.length ? classificationNameArr.filter((item,index) => index <2) : "-";
    },
    isWownowApp: () => {
      return navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
    },
    discountItem() {
      return this.discountTitle;
    }
  },
  methods: {
    urlQueries() {
      let queries = {};
      try {
        let search = window.location.search.match(/\?.*(?=\b|#)/);
        if (search) {
          search = search[0].replace(/^\?/, "");
        }
        if (search) {
          // 单独处理routePath参数
          let routePathIndex = search.indexOf("SuperApp");
          let str1 = search.slice(0, routePathIndex);
          let routePathParam = search.slice(routePathIndex);
          str1.split("&").forEach(item => {
            const param = item.split("=");
            if (param[1]) {
              queries[param[0]] = decodeURIComponent(param[1]);
            }
          });
          queries["routePath"] = decodeURIComponent(routePathParam);
        }
        const routePath = queries.routePath || queries.routepath || ''
        if ((routePath?.indexOf?.('shortID')) !== -1 && queries?.shortID) {
          delete queries.shortID;
        }
        if (
          typeof window?.ssrConfig?.routerConfig?.short?.params === "object" &&
          !Array.isArray(window?.ssrConfig?.routerConfig?.short?.params)
        ) {
          queries = Object.assign(
            {},
            queries,
            window.ssrConfig.routerConfig.short.params
          );
        }
        return queries;
      } catch (err) {
        console.log("整理参数失败: ", err);
        return {};
      }
    },
    ajaxgetImagePath() {
      getImagePath()
        .then(res => {
          console.log(res);
          const { data, rspCd } = res;
          if (rspCd === "00000" && data?.imagePath) {
            this.bgImg = data.imagePath;
          }
        })
        .catch(err => console.log("deverr - getImagePath", err));
    },
    getStoreDetail() {
      if (
        this?.locationQuery?.storeNo &&
        this?.locationQuery?.lon &&
        this?.locationQuery?.lat
      ) {
        this.isLoading = true;
        Vue.filter("loading")(true);
        getStoreDetail(
          {
            storeQuery: encodeURIComponent(
              JSON.stringify({
                storeNo: this?.locationQuery?.storeNo ?? "",
                location: {
                  lon: {
                    $class: "java.math.BigDecimal",
                    $: { value: (this?.locationQuery?.lon ?? "") - 0 }
                  },
                  lat: {
                    $class: "java.math.BigDecimal",
                    $: { value: (this?.locationQuery?.lat ?? "") - 0 }
                  }
                }
              })
            )
          },
          {
            success: res => {
              console.log("detai -> res", res);
              this.detail = res;
              this.isStoreError = false;
              this.getDeliveryFee();
            },
            fail: res => {
              this.isStoreError = true;
            }
          }
        ).finally(() => {
          this.isLoading = false;
        });
      } else {
        this.isStoreError = true;
        this.isLoading = false;
      }
    },
    // 算配送费
    getDeliveryFee() {
      let originFee = this.detail.deliveryFee?.amount || 0;
      let { promotions = [] } = this.detail;
      let deliveryArr = promotions.filter(i => i.marketingType == 19);
      let haveDeliveryActivity = deliveryArr.length > 0;
      // 无活动
      if (!haveDeliveryActivity) {
        originFee > 0
          ? (this.deliveryFee = `$${originFee}`)
          : (this.deliveryFee = this.$t("home.FreeDelivery"));
        return;
      }
      // 有活动的话取活动接口的值 - 不走以下逻辑
      // // 有活动 - 直接减 阶梯减 免
      // if (deliveryArr[0].ladderRules && deliveryArr[0].ladderRules.length) {
      //   if (deliveryArr[0].ladderRules.length == 1) {
      //     console.log("直接减");
      //     let discount = deliveryArr[0].ladderRules[0].discountAmt?.amount || 0;
      //     this.deliveryFee = originFee - discount > 0 ? `$${(originFee - discount).toFixed(2)}`:this.$t("home.FreeDelivery") ;
      //   } else {
      //     console.log("阶梯减");
      //     // 阶梯减 - 未获得距离显示免配送费
      //     this.detail.distance
      //       ? await this.ajaxGetFee()
      //       : (this.deliveryFee = this.$t("home.FreeDelivery"));
      //   }
      // } else {
      //   // 免配送费
      //   console.log("免配送费");
      //   this.deliveryFee = this.$t("home.FreeDelivery");
      // }
    },
    // {"businessType":"13","merchantNo":"07010349","storeNo":"MS1278327685602082816","deliverDistance":0.458,"deliveryAmt":5}:
    ajaxGetFee() {
      let params = {
        businessType: "13",
        merchantNo: this.detail?.merchantNo,
        storeNo: this?.locationQuery?.storeNo ?? "",
        // 转成km
        deliverDistance:
          this.detail?.distance === 0
            ? -1
            : (this.detail?.distance / 1000).toFixed(3),
        deliveryAmt: this.detail.deliveryFee?.amount || 0
      };
      // let params = {
      //   businessType:"13",
      //   merchantNo:"07010349",
      //   storeNo:"MS1278327685602082816",
      //   deliverDistance: -1,
      //   deliveryAmt:150
      // }
      console.log("params", params);
      getDiscountFee(params).then(res => {
        console.log("fee---res", res);
        const { data, rspCd } = res;
        if (rspCd === "00000" && data?.discountAmount) {
          let discount = data.discountAmount?.amount;
          let origin = this.detail.deliveryFee?.amount;
          console.log("计算：", discount, origin);
          if (origin - discount > 0) {
            this.deliveryFee = `$${(origin - discount).toFixed(2)}`;
          } else {
            this.deliveryFee = this.$t("home.FreeDelivery");
          }
        }
      });
    },
    wxOpenLaunchAppClick() {
      this.wechatAppid = "";
      console.log("wxOpenLaunchAppClick");
    },
    launchError() {
      if (this.locationQuery.routePath) {
        this.buttonClick();
      }
    },
    buttonClick() {
      console.log(" this.buttonClick11");
      // 埋点
      this.commonUploadEvenlist({
        event: "opeanAppIcon",
        businessName: "拉起APP按钮点击",
        type: "opeanAppIcon"
      });

      this.checkMasking(isOpenClick => {
        if (isOpenClick) {
          this.btnActive = true;
          this.$nextTick(() => {
            const __timeout = setTimeout(() => {
              clearTimeout(__timeout);
              this.btnActive = false;
              this.$nextTick(() => {
                this.goRoutePath();
              });
            }, 100);
          });
        }
      });
    },
    checkMasking(callback) {
      this.isShowMasking = !!(this.isWechat || this.isDingTalk || this.isQQ);
      typeof callback === "function" && callback(!this.isShowMasking);
    },
    goRoutePath() {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        this.$nextTick(() => {
          if (process.env.NODE_ENV === "development") {
            window.location.href = `/wownow/down-loading/index?${this
              .locationQuery.fromId &&
              "fromId=" + this.locationQuery.fromId + "&"}routePath=${
              this.routePath
            }`;
          } else {
            window.location.href = `/mobile-h5/wownow/down-loading?${this
              .locationQuery.fromId &&
              "fromId=" + this.locationQuery.fromId + "&"}routePath=${
              this.routePath
            }`;
          }
        });
      }, 1000);
      console.log("currentSchemeUrl: ", this.routePath);
      window.location.href = this.routePath;
    },
    // 获取用户信息，justget为true则不跳转登录页
    getOperator(justget = false) {
      return new Promise((resolve, reject) => {
        this.$root.timeout(() => {
          if (this.isWownowApp && window?.WOWNOW?.getUserInfo) {
            window.WOWNOW.getUserInfo({
              success: res => {
                if (res && res.loginName) {
                  storage.setItem("loginName", res.loginName);
                  storage.setItem("operatorNo", res.operatorNo);
                  this.userInfo.loginName = res.loginName;
                  this.userInfo.operatorNo = res.operatorNo;
                  resolve(res);
                }
              },
              fail: res => {
                storage.remove("loginName");
                storage.remove("operatorNo");
                console.log("get user info fail");
                if (!justget) {
                  console.log("!juseget");
                  window?.WOWNOW?.navigationToRoute({
                    route: "SuperApp://SuperApp/login"
                  });
                }
                reject();
              }
            });
          } else {
            console.error("当前环境没有js sdk");
            reject();
          }
        });
      });
    },
    // 埋点
    commonUploadEvenlist(obj) {
      const _this = this;
      const { type, businessName, event } = obj;
      // wechat 、facebook 、其他
      const fromArr = [
        {
          code: this.isWechat,
          msg: "wechat"
        },
        {
          code: this.isFaceBook,
          msg: "facebook"
        },
        {
          code: !this.isWechat && !this.isFaceBook,
          msg: "其他"
        }
      ];
      uploadEventList([
        {
          businessName,
          eventGroup: "other",
          event,
          ext: {
            type,
            deviceId: storage.getItem("device-id"),
            time: new Date().getTime(),
            from: fromArr.filter(i => i.code)[0].msg
          },
          operatorNo: _this.isWownowApp
            ? _this.userInfo.operatorNo || null
            : null
        }
      ]);
    }
  }
};
</script>
<style lang="stylus" scoped>
.mask-group-background {
  z-index: -1;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: cover;
}
em {
  font-style: normal;
}
.position-absolute {
  position: absolute;
}
.share-store {
  position: relative;
  // background: url('./images/bg.png') no-repeat;
}
.header-box {
  // margin-top: 112px;
  position: absolute;
  display: flex;
  flex-direction: column;
  color:#fff;
  top: 20px;
  left: 16px;
  // padding: 0 16px;
  .wownow-logo {
    overflow: hidden;
    width: 80px;
    height: 36px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    margin-top: 15px;
    max-width: 237px;
    height: 64px;
    font-size: 24px;
    font-family: BerthaBold-Regular, BerthaBold;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 29px;
  }
}
.no-store {
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 180px;
  width: 100%;
  img {
    width: 200px;
    height: 200px;
    margin-bottom: 8px;
  }
  .no-tip {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 21px;
  }
}
.content-box {
    top: 120px;
    width: 100%;
    left: 0;
}
.logo-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo {
    width: 74px;
    height: 74px;
    box-sizing: content-box;
    border-radius: 50%;
    padding: 2px;
    background: #fff;
    overflow:hidden;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .name {
    margin-top: 7px;
    font-size: 18px;
    min-height: 24px;
    font-family: SanFranciscoText-Bold, SanFranciscoText;
    font-weight: bold;
    color: #333333;
    line-height: 24px;
    word-break: break-all;
    padding: 0 20px;
    display: -webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .desc-box {
    width: 338px;
    margin: 8px 0 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: SanFranciscoText-Regular, SanFranciscoText;
    font-weight: 400;
    color: #333333;
    .item {
      display: flex;
      align-items: center;
      line-height: 24px;
    }
    .point {
      margin: 0 4px;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 2px;
    }
  }
}
.info-box {
  width: 338px;
  // max-height: 181px;
  background: #FFFFFF;
  border-radius: 5px;
  margin: 0 auto;
  padding: 16px 14px;
  .item {
    display: flex;
    margin-bottom: 13px;
    align-items: center;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .title {
    display: inline-block;
    height: 20px;
    background: #FC2040;
    border-radius: 3px;
    font-size: 14px;
    padding: 0 4px;
    line-height: 20px;
    font-family: SanFranciscoText-Regular, SanFranciscoText;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    margin-right: 8px;
  }
  em {
    height: 23px;
    line-height: 23px;
    flex:1;
    font-size: 15px;
    font-family: SanFranciscoText-Medium, SanFranciscoText;
    font-weight: 500;
    color: #333333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.btn {
  margin: 16px auto 0;
  width: 285px;
  height: 44px;
  background: #FC2040;
  border-radius: 22px;
  font-size: 16px;
  font-family: SanFranciscoText-Bold, SanFranciscoText;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 44px;
  padding: 0 4px;
  box-sizing: border-box;
  text-align: center;
}


/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: opacity .5s;
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: opacity .5s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.masking {
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-color: rgba(46, 45, 45, 0.8);
}

.masking-content {
  width: 100%;
  height: 100%;
  position: relative;
}
.masking-tips-site {
  width: fit-content;
  height: 78px;
  color: #fff;
  font-weight: bold;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index 999
}
.tips-text {
  font-size: 20.5px;
}
.blue-menu {
  margin: 0 5px;
  width: 26px;
}
.blue-button {
  margin: 0 5px;
  width: 160px;
}
.blue-button-site {
  position relative
}
.round {
  width: 18px;
  height: 18px;
  line-height 18px;
  border-radius: 50%;
  background-color #ff6d00
  font-size: 15.5px;
  text-align center
  margin-right 10px;
}
.earth {
  width: 22px;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 10px;
}
.earth-text {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 38px;
  font-size: 14px;
}
.tips-row {
  margin-bottom: 18px;
}
</style>
